import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Cookies from 'js-cookie'
// import Vant from 'vant'
// import 'vant/lib/button/style/less'
import { Toast } from 'vant'

import { common } from '@/utils/common'
import '@/utils/filters'
import request from '@/utils/request'
import '@/utils/validate'

// https://juejin.im/post/5d0361e66fb9a07f0052d7e7 微信授权
// todo open
// import '@/permission' // permission control
// import wechatAuth from './plugins/wechatAuth' // 微信登录插件
// // 设置appid
// Vue.use(wechatAuth, {
//   appid: process.env.VUE_APP_WECHAT_APPID
// })

Vue.config.productionTip = false

// import preview from 'vue-photo-preview'
// import 'vue-photo-preview/dist/skin.css'

Vue.prototype.$http = request
Vue.prototype.$common = common
Vue.use(Toast)
// Vue.use(preview, {
//   fullscreenEl: false,
//   zoomEl: false
// })

// Vue.use(Vant)

router.beforeEach((to, form, next) => {
  if (Cookies.get('userId')) {
    store.commit('user/SET_USERID', Cookies.get('userId'))
    store.commit('user/SET_TOKEN', Cookies.get('token'))
    // store.commit('user/SET_TOKEN', 'd0409cc9ee1b49a09a75edaedaaf38e048b') // 超时
    store.commit('user/SET_USERINFO', Cookies.get('userInfo'))
  }

  if (to.meta.title) {
    if (to.path === '/home' && to.query.type === 'loc') {
      document.title = '门诊导航'
    } else {
      document.title = to.meta.title
    }
  }
  next()
})

// router.afterEach((to, from) => {
//   require('viewport-units-buggyfill').init()
//   // require('viewport-units-buggyfill').refresh()
// })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
